import React from 'react';

export interface ValidationMessageProps {
    invalidRules?: string[];
    rule?: boolean;
    showBeforeSubmit?: boolean;
    submitted?: boolean;
    type: string;
    valid?: boolean;
    children?: React.ReactNode;
    className?: string;
}
function ValidationMessage({
    invalidRules = [],
    rule = false,
    showBeforeSubmit = false,
    submitted = false,
    type,
    valid = false,
    children,
    className,
}: ValidationMessageProps) {
    function shouldDisplay() {
        if (!submitted && !showBeforeSubmit) {
            return false;
        }
        if (type === 'external' && rule) {
            return true;
        }
        if (valid) {
            return false;
        }
        if (!type) {
            return true;
        }
        return invalidRules && invalidRules.includes(type);
    }

    if (!shouldDisplay()) return null;

    return <div className={`${className || ''} zp-form-validation-message`}>{children}</div>;
}

export { ValidationMessage };
